"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestIds = void 0;
exports.TestIds = {
    overflow: 'responsive-container-overflow',
    content: 'responsive-container-content',
};
//# sourceMappingURL=constants.js.map